const ReduxSliceNames = {
  LoadingFullScreen: 'LoadingFullScreen',
  Companies: 'Companies',
};

export default ReduxSliceNames;
